module.exports = __webpack_public_path__ + "img/landscapes_with_smartphone_splash.1e187946.jpg";